export default {
  install: (app) => {
    app.config.globalProperties.$formatPrice = (price, showCurrency = true, minimumFractionDigits = 2, maximumFractionDigits = 2) => {
      let options = null;

      if (showCurrency) {
        options = {
          style: "currency",
          currency: app.config.globalProperties.$store.state.app.currency,
          minimumFractionDigits: minimumFractionDigits,
          maximumFractionDigits: 2,
        };
      } else {
        // 判断是否为整数
        const isInteger = Number.isInteger(price);
        options = {
          style: "decimal",
          minimumFractionDigits: isInteger ? 0 : minimumFractionDigits,
          maximumFractionDigits: isInteger ? 0 : maximumFractionDigits,
        };
      }

      return new Intl.NumberFormat(
        app.config.globalProperties.$store.state.app.locale,
        options
      ).format(price ?? 0);
    }
  }
}